let descriptions
const newLine = '\r\n'

const requestParameters = {
  infographics: {
    id: 'infographics',
    state: {
      include: false,
      outdoorInfographics: 0,
      indoorInfographics: 0,
      insertInPicture: false,
    }
  },
  _3dAnimation: {
    id: '3d-animation',
    state: {
      include: false,
      animationMinutes: '0:00',
      animationResolution: '-',
      insertDroneFlight: false
    }
  },
  virtualTour: {
    id: 'virtual-tour',
    state: {
      include: false,
      checkpoints: 0,
      insertVRHeadsetVersion: false,
    }
  },
  virtualReality: {
    id: 'virtual-reality',
    state: {
      include: false,
      insertInteractives: false,
      insertVoiceOvers: false,
      insertHolograms: false
    }
  }
}

export function initQuote() {
  initSidebarManualCloseListeners()

  descriptions = JSON.parse(document.getElementById('quote-request').dataset.descriptions)

  initCheckBox('infographics', 'infographics')
  initCheckBox('3d-animation', '_3dAnimation')
  initCheckBox('virtual-tour', 'virtualTour')
  initCheckBox('virtual-reality', 'virtualReality')

  document.getElementById('outdoor-infographics').addEventListener('input', setOutdoorInfographics)
  document.getElementById('indoor-infographics').addEventListener('input', setIndoorInfographics)
  document.getElementById('animation-minutes').addEventListener('input', setAnimationMinutes)
  document.getElementById('animation-resolution').addEventListener('input', setAnimationResolution)
  document.getElementById('checkpoints').addEventListener('input', setCheckpoints)

  document.querySelectorAll('.param-value-toggle')
          .forEach(toggle => toggle.addEventListener('click', toggleValue))

  document.querySelectorAll('.question-mark')
          .forEach(questionMark => {
            questionMark.addEventListener('mouseenter', showTooltip)
            questionMark.addEventListener('mouseleave', hideTooltip)
            questionMark.addEventListener('click', showTooltip)
          })

  updateDOM()
}

function initSidebarManualCloseListeners() {

  const closeSidebar = () => {
    console.log('closing sidebar manually')
    $.sidr('close', 'sidr')
  }

  document.getElementById('quote-request').addEventListener('click', closeSidebar)
}

function initCheckBox(htmlName, paramName) {
  const checkbox = document.getElementById(`${htmlName}-check`)

  checkbox.addEventListener('click', () => toggleParameters(paramName))
  requestParameters[paramName].state.include = checkbox.checked
}


function showTooltip () {
  const button = this.parentElement
  const tooltip = button.querySelector('.tooltip')

  button.classList.add('no-pointer')
  tooltip.classList.remove('hidden')
  setTimeout(() => tooltip.classList.remove('invisible'), 0)
}

function hideTooltip () {
  const button = this.parentElement
  const tooltip = button.querySelector('.tooltip')

  button.classList.remove('no-pointer')
  tooltip.classList.add('invisible')
  setTimeout(() => tooltip.classList.add('hidden'), 200)
}

function toggleParameters(parameterName) {
  const parameterState = requestParameters[parameterName].state
  parameterState.include = !parameterState.include

  updateDescription()
}

function setOutdoorInfographics() {
  setParameterValue('infographics', 'outdoorInfographics', parseInt(this.value))
}

function setIndoorInfographics() {
  setParameterValue('infographics', 'indoorInfographics', parseInt(this.value))
}

function setAnimationMinutes() {
  const seconds = parseInt(this.value)
  const minutes = Math.floor(seconds / 60)
  const remainingSeconds = seconds % 60

  const time = `${minutes}:${remainingSeconds < 10 ? '0' + remainingSeconds : remainingSeconds}`

  setParameterValue('_3dAnimation', 'animationMinutes', time)
}

function setAnimationResolution() {

  const ind = parseInt(this.value)
  let resolution

  switch (ind) {
    case 0 :
      resolution = '-'
      break
    case 1 :
      resolution = 'HD 1280 x 720'
      break
    case 2 :
      resolution = 'FULLHD 1920 x 1080'
      break
    case 3 :
      resolution = '2K 2560 x 1440'
      break
    case 4 :
      resolution = '4K 3840 x 2160'
      break
    case 5 :
      resolution = '8K 7680 x 4320'
      break
    default :
      throw new Error(`Invalid animation resolution index: ${ind}`)
  }

  setParameterValue('_3dAnimation', 'animationResolution', resolution)
}

function setCheckpoints() {
  setParameterValue('virtualTour', 'checkpoints', parseInt(this.value))
}

function setParameterValue(parameter, stateName, value) {
  requestParameters[parameter].state[stateName] = value
  updateDescription()
}

function toggleValue(e) {
  const button = e.currentTarget

  button.classList.toggle('active')

  const parameter = button.dataset.parameter
  const value = button.dataset.value

  requestParameters[parameter].state[value] = !requestParameters[parameter].state[value]

  updateDescription()
}

function updateDescription() {
  let description = ''

  const { infographics, _3dAnimation, virtualTour, virtualReality } = requestParameters

  if (infographics.state.include)
    description += formatInfographics(infographics.state)

  if (_3dAnimation.state.include)
    description += format3DAnimation(_3dAnimation.state)

  if (virtualTour.state.include)
    description += formatVirtualTour(virtualTour.state)

  if (virtualReality.state.include)
    description += formatVirtualReality(virtualReality.state)

  updateDOM(description)
}

function updateDOM(description='') {
  const projectDescription = document.getElementById('project-description')
  const projectDescriptionValue = document.getElementById('project-description-value')

  // projectDescription.value = description
  projectDescriptionValue.value = description

  for (const parameter of Object.values(requestParameters)) {
    const checkbox = document.getElementById(`${parameter.id}-check`)
    const include = parameter.state.include

    checkbox.checked = include

    toggleCollapse(`${parameter.id}-parameters`, !include)
  }

  document.getElementById('outdoor-infographics-value').textContent = requestParameters.infographics.state.outdoorInfographics
  document.getElementById('indoor-infographics-value').textContent = requestParameters.infographics.state.indoorInfographics
  document.getElementById('animation-minutes-value').textContent = requestParameters._3dAnimation.state.animationMinutes
  document.getElementById('animation-resolution-value').textContent = requestParameters._3dAnimation.state.animationResolution
  document.getElementById('checkpoints-value').textContent = requestParameters.virtualTour.state.checkpoints
}

function toggleCollapse(id, collapse) {
  const element = document.getElementById(id)

  if (collapse)
    element.classList.add('collapsed')
  else
    element.classList.remove('collapsed')
}


function formatInfographics({ outdoorInfographics, indoorInfographics, insertInPicture }) {
  let description = ''

  if (outdoorInfographics)
    description += `\t- ${descriptions.outdoor_infographics}: ${outdoorInfographics} ${newLine}`

  if (indoorInfographics)
    description += `\t- ${descriptions.indoor_infographics}: ${indoorInfographics} ${newLine}`

  if (insertInPicture)
    description += `\t- ${descriptions.infographic_insert_in_pic} ${newLine}`

  description = description ? `${descriptions.infographics}: ${newLine} ${description}` : description

  return description + newLine
}

function format3DAnimation({ animationMinutes, animationResolution, insertDroneFlight }) {
  let description = ''

  if (animationMinutes !== '0:00')
    description += `\t- ${descriptions.animation_minutes}: ${animationMinutes} ${newLine}`

  if (animationResolution !== '-')
    description += `\t- ${descriptions.animation_resolution}: ${animationResolution} ${newLine}`

  if (insertDroneFlight)
    description += `\t- ${descriptions.animation_drone_flight} ${newLine}`

  description = description ? `${descriptions._3d_anim}: ${newLine} ${description}` : description

  return description + newLine
}

function formatVirtualTour({ checkpoints, insertVRHeadsetVersion }) {
  let description = ''

  if (checkpoints)
    description += `\t- ${descriptions.checkpoints}: ${checkpoints} ${newLine}`

  if (insertVRHeadsetVersion)
    description += `\t- ${descriptions.vr_headsets} ${newLine}`

  description = description ? `${descriptions.virtual_tour}: ${newLine} ${description}` : description

  return description + newLine
}

function formatVirtualReality({ insertInteractives, insertVoiceOvers, insertHolograms }) {
  let description = ''

  if (insertInteractives)
    description += `\t- ${descriptions.interaction} ${newLine}`

  if (insertVoiceOvers)
    description += `\t- ${descriptions.voice_overs} ${newLine}`

  if (insertHolograms)
    description += `\t- ${descriptions.holograms} ${newLine}`

  description = description ? `${descriptions.virtual_reality}: ${newLine} ${description}` : description

  return description + newLine
}
